import { component } from 'picoapp';
import $ from 'quantdom';
import { InfiniteScroll } from '../lib/infinite-scroll';
import { get } from '../lib/ajax';
import { setCookie, getCookie } from '../lib/utils';

export default component((node) => {
	const url = new URL(window.location);
	const params = url.searchParams;
	const totalProducts = parseInt($(node).attr('data-products-count'));
	const productsPerPage = parseInt($(node).attr('data-products-per-page'));
	const totalPages = Math.ceil(totalProducts / productsPerPage);
	let currentPage = parseInt(params.get('page')) || 1;
	let currentNumProducts = currentPage * productsPerPage;
	if (params.get('page') && currentPage <= totalPages) {
		getPagesUntilCurrent();
	}

	function getPagesUntilCurrent() {
		let promises = [];
		for (let i = 1; i < currentPage; i++) {
			promises.push(get(`${url.origin}${url.pathname}?page=${i}`));
		}

		Promise.all(promises).then((res) => {
			res.forEach((data) => {
				const frameSelection = $('.js-collection-grid').attr(
					'data-frame-selection'
				);

				const parser = new DOMParser();
				const doc = parser.parseFromString(data, 'text/html');
				if (frameSelection) {
					const imageFrames = doc.querySelectorAll(
						'.collection-item-images [data-frame]'
					);
					imageFrames.forEach((el) => {
						el.setAttribute('data-frame', frameSelection);
						console.log(el, frameSelection);
					});
				}
				const pageNumber =
					new URL(
						doc.querySelector(`[property="og:url"]`).content
					).searchParams.get('page') || 1;

				doc.querySelectorAll('.placeholder').forEach((elem) => {
					elem.remove();
				});

				const html = doc.querySelector('.js-collection-grid').innerHTML;
				$('.js-collection-paginate .js-load-next').attr('aria-busy', 'false');
				$('.js-collection-paginate .js-load-all').attr('aria-busy', 'false');
				console.log(` removing .placeholder.page-${pageNumber}`);
				document
					.querySelectorAll(`.placeholder.page-${pageNumber}`)
					.forEach((elem) => {
						elem.remove();
					});
				$('.js-collection-grid').prepend(html);
			});
			//scrolls to top of current page
			const els = $('.js-collection-item').els;
			const el = els[els.length - productsPerPage];
			const { top } = el.getBoundingClientRect();
			const offset = window.scrollY + top - 200;
			window.scrollTo({ top: offset, left: 0, behavior: 'instant' });
		});
	}

	function setCurrentState(page) {
		currentPage = page;
		params.set('page', currentPage);
		currentNumProducts = currentPage * productsPerPage;
		$('collection-progress-bar').attr('current', currentPage);
		if (currentPage === totalPages) {
			$('.js-collection-paginate .js-load-next').hide();
			$('.js-collection-paginate .js-load-all').hide();
			$('.js-collection-paginate .js-main-loader').hide();
			$('.js-collection-paginate .js-products-shown').text(totalProducts);
		} else {
			$('.js-collection-paginate .js-load-next').attr('aria-hidden', false);
			$('.js-collection-paginate .js-products-shown').text(currentNumProducts);
		}
	}

	$('.js-collection-paginate .js-load-next').on('click', (e) => {
		$(e.target).attr('aria-busy', 'true');
		if (currentPage < totalPages) {
			getPage();
		}
	});

	function getPage() {
		setCurrentState(currentPage + 1);
		get(url)
			.then((res) => {
				const frameSelection = $('.js-collection-grid').attr(
					'data-frame-selection'
				);

				const parser = new DOMParser();
				const doc = parser.parseFromString(res, 'text/html');
				if (frameSelection) {
					const imageFrames = doc.querySelectorAll(
						'.collection-item-images [data-frame]'
					);
					imageFrames.forEach((el) => {
						el.setAttribute('data-frame', frameSelection);
						console.log(el, frameSelection);
					});
				}
				doc.querySelectorAll('.placeholder').forEach((elem) => {
					elem.remove();
				});
				const html = doc.querySelector('.js-collection-grid').innerHTML;
				$('.js-collection-paginate .js-load-next').attr('aria-busy', 'false');
				$('.js-collection-paginate .js-load-all').attr('aria-busy', 'false');
				$('.js-collection-grid').append(html);
				history.replaceState({}, '', url);
			})
			.catch((e) => {
				console.log('error', e);
			});
	}

	function infiniteScrollProductGrid() {
		window.productScroll = new InfiniteScroll(
			{
				el: '.js-collection-paginate',
				options: {
					root: null,
					rootMargin: '0px 0px 70% 0px',
				},
			},
			() => {
				console.log({ currentPage: currentPage, totalPages: totalPages });
				if (currentPage < totalPages) {
					getPage();
				} else {
					window.productScroll.stop();
				}
			}
		);
	}

	$('.js-load-all').on('click', (e) => {
		e.preventDefault();
		$(e.target).attr('aria-busy', 'true');
		$('.js-collection-paginate .js-load-next').hide();
		$('.js-collection-paginate .js-load-all').hide();
		$('.js-collection-paginate .js-main-loader').show(true);
		$('.js-collection-paginate .progressbar-wrapper').hide();
		infiniteScrollProductGrid();
	});
});
